import { Box, Typography, styled } from '@mui/material'
import { Body2 } from '@collaborate-health/uikit'

export const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  marginBottom: theme.spacing(2),
}))

export const Header = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'start',
})

export const Content = styled('div')({
  flexGrow: 1,
})

export const Actions = styled('div')({
  display: 'flex',
  flexGrow: 1,
  flexDirection: 'row',
  justifyContent: 'end',
})

export const Name = styled(Body2)(({ theme }) => ({
  fontWeight: 500,
  marginBottom: theme.spacing(),
}))

export const Time = styled(Typography)(({ theme }) => ({
  fontSize: 9,
}))

